var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDropdownDown = function SvgIconDropdownDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10 0C4.478 0 0 4.477 0 10s4.477 10 10 10 10-4.478 10-10S15.523 0 10 0m0 2a8 8 0 0 1 0 15.999 8 8 0 1 1 0-16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.708 9.707a1 1 0 0 0-1.415-1.415l-2.292 2.293-2.294-2.293a1 1 0 1 0-1.413 1.415l3 3a1 1 0 0 0 1.413 0z"
  }))));
};
export default SvgIconDropdownDown;